import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyWhyChooseUsItems } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";

export function useDeleteAllWhyChooseUsItems() {
    const queryClient = useQueryClient();

    const { mutate: deleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massDestroyWhyChooseUsItems,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete items");
        },
    });

    return { deleteAllItemsMutate, isPending };
}
